export default function cardholderIdField(tm1346, tm1347) {
  return `
  <div id="primer-checkout-cardholder-id-field" class="PrimerCheckout__formField mb-[25px] mt-7.5">
    <div class="flex justify-center items-center">
      <div id="document-type-wrapper" class="relative max-w-fit mr-3 flex justify-between items-center cursor-pointer text-penta bg-delta !border !border-solid !border-mezo rounded-lg text-normal font-normal h-[46px] py-2.75 px-3.75 w-full">
        <div id="document-type-choice" class="pr-3"></div>

        <div class="iti__arrow"></div>
      </div>
      <div class="relative w-full">
        <div class="sc-fotOHu kBcYUA PrimerCheckout__label cardholder-id-label">${tm1346}</div>
        <div id="primer-checkout-card-cardholder-id-input-wrapper" class="sc-jRQBWg cMQtha">
          <input id="primer-checkout-card-cardholder-id-input" class="sc-ksdxgE gbrwZH PrimerCheckout__formInput" type="tel" placeholder="">
        </div>
      </div>
    </div>
    <div id="primer-checkout-cardholder-id-error" class="sc-kDTinF jDibtd">
      <div class="PrimerCheckout__helperText PrimerCheckout__helperText--error PrimerCheckout--exit PrimerCheckout--exited PrimerCheckout--hidden" aria-hidden="true">${tm1347}</div>
    </div>
  </div>`;
}
